<template>
  <div class="profile">
    <span>{{ $t('meta_title.profile') }}</span>

    <div v-if="user && user.email">
      <p><strong>{{user.firstname}} {{user.lastname}}</strong></p>
      <p><strong>{{user.email}}</strong></p>
      <p>{{ $t('role.' + user.role) }}</p>
    </div>

  </div>
</template>

<script>

  export default {
    name: 'Profile',
    data() {
      return {
        user: {
          firstname: null,
          lastname: null,
          email: null,
          role: null,
        },
      }
    },
    created() {
      this.$http.get(`profile`)
        .then(response => {
          this.user      = response.data
          this.user.role = this.user.roles[0]
        })
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/Security/profile.vue